import { RenderPipeline } from '../RenderPipeline'
import type { QueryStoreInput, QueryStoreOutput } from './QueryStore'

const setStore = () =>
  RenderPipeline.updateOutput(
    (_output: Partial<QueryStoreOutput>, ctx: { input: QueryStoreInput }) => ({
      store: ctx.input.store,
    }),
  )

export const QueryStoreOutputParts = {
  setStore,
}
